module.exports = __webpack_public_path__ + "static/media/convention_nav.2e86a8ab.svg";